import React from "react";

export default function TopBar({name, onMenuToggle, showMenu}) {
  return (
    <div className="top-bar header">
      {showMenu && (
        <button className="hamburger-menu" onClick={onMenuToggle} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}
      <div className="title">
        [ {name} ]
      </div>
    </div>
  );
}
